import React, { useRef, useState, useEffect } from "react";
import Draggable from "react-draggable";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ModalTitle from "react-bootstrap/ModalTitle";

const DraggableContainer = ({ children, titleName, showing, handleHide }) => {
  const containerRef = useRef(null);
  const [dimensions, setDimensions] = useState({});

  useEffect(() => {
    const updateDimensions = () => {
      const { offsetWidth, offsetHeight } = containerRef.current;
      setDimensions({ width: offsetWidth, height: offsetHeight });
    };

    // Update dimensions when the component mounts and on window resize
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);

  const handleClose = () => {
    // Implement close functionality here
  };

  return (
    <Draggable handle=".draggable-handle">
      <div
        ref={containerRef}
        className="modal show"
        style={{
          display: showing ? "inline-block" : "none",
          position: "absolute",
          top: 200 + "px",
          left: 600 + "px",
          width: "auto",
          height: "auto",
        }}
      >
        <Modal.Dialog style={{ margin: "0 0", maxWidth: 'unset' }} >
          <Modal.Header
            closeButton onHide={handleHide}
            className="draggable-handle"
            style={{ height: "18px", cursor: 'default' }}
          >
            <Modal.Title as={"p"}>{titleName}</Modal.Title>
          </Modal.Header>

          <Modal.Body>{children}</Modal.Body>

          {/* <Modal.Footer>
          <Button variant="secondary">Close</Button>
          <Button variant="primary">Save changes</Button>
        </Modal.Footer> */}
        </Modal.Dialog>
      </div>
    </Draggable>
  );
};

export default DraggableContainer;
